import { LISTING_TYPE_PLURAL_HUMAN_NAME_MAP_TITLE } from 'utils/constants';

export const PAGE_HEADER_NAV_MAP = {
  ...LISTING_TYPE_PLURAL_HUMAN_NAME_MAP_TITLE,
  HOME: 'Idealist.org',
  GRAD_PROGRAM: getText('Grad Schools'),
  VOLOP: getText('Volunteer +'),
  BLOG: getText('Blog'),
  QUEUES: getText('Queues'),
  REPORTS: getText('Reports'),
  CREATE_PAYMENT: getText('Create Payment'),
  GRAD_FAIRS: getText('Grad Fairs'),
  EMAIL_PROMO: getText('Email Promos'),
  ACTION_LOG: getText('Action Log'),
  CMS: getText('CMS'),
  JOB_CREDIT_PROMO_LINKS: getText('Job Credit Promo Links'),
};

export const PAGE_HEADER_PATH_MAP = {
  ...PAGE_HEADER_NAV_MAP,
  // for flow
  HOME: '/',
  QUEUES: 'staff/queues/assigned-to-me',
  REPORTS: 'staff/reports',
  CREATE_PAYMENT: 'staff/payments/create',
  GRAD_FAIRS: 'staff/grad-fairs',
  EMAIL_PROMO: 'staff/email-promos',
  ACTION_LOG: 'staff/action-log',
  CMS: 'cms',
  JOB_CREDIT_PROMO_LINKS: 'staff/job-credit-promo-links',
};

export const PAGE_HEADER_NAV = {
  MAIN: ['JOB', 'INTERNSHIP', 'VOLOP', 'ORG', 'GRAD_PROGRAM', 'BLOG'],
  STAFF: [
    'HOME',
    'QUEUES',
    'REPORTS',
    'CREATE_PAYMENT',
    'ACTION_LOG',
    'GRAD_FAIRS',
    'EMAIL_PROMO',
    'CMS',
    'JOB_CREDIT_PROMO_LINKS',
  ],
};
